import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import Avatar from '@components/avatar';
import { BASE_IMG_URL, livePhotoImage, setPostImage } from '@images/imageUrls';
import VoteList from '@components/voteList';
import { formatTime } from '@utils/timeUtils';
import { copy } from '@utils/copy';
import AvatarList from '@components/avatarList';
import CommonPopup from '@components/commonPopup';
import CommonPopupNew from '@components/commonPopupNew';
import CommonAlert from '@components/commonAlert';
import ManagePermissions from '@components/managePermissions';
import classNames from 'classnames';
import { Radio, Input, DatePickerProps, DatePicker, Checkbox } from 'antd';
import parse, { domToReact } from 'html-react-parser';
import Toast from '@components/Toast';
import PostList from '@components/postList';
import { Image, Spin } from 'antd';
import dayjs from 'dayjs';
import { Carousel } from 'antd';
const { TextArea } = Input;
import updateImageListSrc from '@utils/update-image-list-src'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { formatNumberToWan } from '@utils/formatNumber';
import CountDown from "@components/countDown";
import {
    getProtectedEventHandlers,
    isContentProtectionEnabled,
    protectedMediaStyle,
} from '@utils/contentProtection';
import { replaceEmojiCodes } from '@utils/emoji';
// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './index.scss'
import { px2rem } from '@utils/px2rem';
import { getUrlWhitelist, cleanHttpLinks } from '@utils/whiteList';
import { getFeedbackStatus, getThreadPresentation } from './threadPresentation';
import ThreadDetailVideo from './ThreadDetailVideo';
import { getFormOptionText } from '../common/formOptions';
import { moveThread } from '@server';
import type { ThreadConversionPayload } from '@components/threadConversion';
import { getThreadConversionAccess, getThreadConversionBlockedReason, getThreadConversionParams } from '@utils/threadConversion';

interface ThreadDetailPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    threadId?: any
    // createThreadOpera?: any
    createFollowUser?: any
    followDelete?: any
    createActivityVote?: any
    threadAuthorInfo?: any
    isVivoBrowserStatus: any
    // 下发的通用操作方法
    likeClick?: (data: any, type: 'thread' | 'post') => Promise<any> | void
    favoriteClick?: (status: boolean) => Promise<any> | void
    shareClick?: () => void
    postsUpdate?: (id: any, actionType: 'delete' | 'sink' | 'sticky', type: 'post' | 'comment', currentState?: boolean) => Promise<any>
    submitFeedbackSame?: () => void
    handleState?: (data: any) => void
    sendConfirmClick?: (solveStatus: number) => void
    sendConfirmPopupStatus?: boolean
    serviceStatus: boolean    // 客服反馈入口是否显示
    satisfactionLevel?: any  // 解决问题的满意程度
    currentSatisfactionIndex?: any  // 当前解决问题的满意程度
    judgeTextValue?: any    // 本次反馈服务的评价或建议
}
interface ThreadDetailPCState {
    loading: boolean;
    error: any
    pageLoaded: any
    topicList?: any
    rewardPopupStatus: boolean
    rewardCheckValue: any
    reportPopupStatus: boolean
    reportReasonList: any
    reportReason: any
    reportDescription: any
    menuDropStatus: any
    selectedCommentId?: any  // 当前选中要操作的评论 id
    selectedCommentIsSink?: boolean  // 当前选中评论的沉贴状态
    selectedCommentIsSticky?: boolean  // 当前选中评论的置顶状态
    deletePopupStatus: boolean
    swiperActiveIndex?: any
    livePlayingIndex: number | null
    liveMuted: boolean
    reportType?: any
    reportCommentId?: any
    formInfo: any[]  // 表单字段数组
    formCreateAt: string  // 表单创建时间
    consentStatus: boolean  // 用户是否同意
    submitStatus: boolean  // 是否可提交
    popupStatus: boolean  // 表单弹窗显示状态
    auditStatus: boolean  // 审核状态
    formSubmittedData: any[]  // 已提交的表单数据缓存
    formCountdown: any  // 表单倒计时显示文本或对象
    formStatus: 'notStarted' | 'ongoing' | 'ended'  // 表单状态
    formSubmitConfirmVisible: boolean  // 表单提交确认弹窗显示状态
    rightFixedBoxRight: number  // rightFixedBox 的 right 值
    rightFixedBoxHeight: number  // rightFixedBox 的高度
    showRightFixedBox: boolean  // 是否显示 rightFixedBox
    whiteList: string[]
    whiteHttpList: string[]
}
@inject('app', 'site', 'user', 'thread')
@observer
class ThreadDetailPCPage extends BasePage<ThreadDetailPCPageProps, ThreadDetailPCState> {
    private liveVideoRefs: Map<number, HTMLVideoElement> = new Map();
    private wrapperRef: HTMLDivElement | null = null;
    private rightContentRef: HTMLDivElement | null = null;
    private rightFixedBoxRef: HTMLDivElement | null = null;
    private docContextMenuHandler: ((e: MouseEvent) => void) | null = null;
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        topicList: [],
        rewardPopupStatus: false,    // 打赏弹框
        rewardCheckValue: 0,    // 打赏V币数
        reportPopupStatus: false,    // 举报弹框
        formInfo: [],  // 表单字段数组
        formCreateAt: '',  // 表单创建时间
        consentStatus: false,  // 用户是否同意
        submitStatus: false,  // 是否可提交
        popupStatus: false,  // 表单弹窗显示状态
        auditStatus: false,  // 审核状态
        formSubmittedData: [],  // 已提交的表单数据缓存
        formCountdown: '',  // 表单倒计时
        formStatus: 'notStarted' as 'notStarted' | 'ongoing' | 'ended',  // 表单状态
        formSubmitConfirmVisible: false,  // 表单提交确认弹窗显示状态
        reportReasonList: [
            { value: '淫秽色情', label: '淫秽色情' },
            { value: '垃圾广告', label: '垃圾广告' },
            { value: '暴力恐怖', label: '暴力恐怖' },
            { value: '违规传播', label: '违规传播' },
            { value: '政治谣言', label: '政治谣言' },
            { value: '谩骂侮辱', label: '谩骂侮辱' },
            { value: '灌水发帖/评论', label: '灌水发帖/评论' },
            { value: '其他', label: '其他' },
        ],
        reportReason: '',   // 举报理由
        reportDescription: '',  // 举报描述
        menuDropStatus: false,  // 标题右侧管理下拉框状态，默认折叠
        selectedCommentId: '',  // 当前选中要操作的评论 id
        selectedCommentIsSink: false,
        selectedCommentIsSticky: false,
        deletePopupStatus: false,   // 删除二次确认弹框
        swiperActiveIndex: 0,   // 动态帖图片轮播索引
        livePlayingIndex: null as number | null,  // 正在播放live图的索引
        liveMuted: true,  // live图是否静音
        reportType: 1,  // 举报类型0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
        reportCommentId: '',    // 举报的评论id
        rightFixedBoxRight: 0,  // rightFixedBox 的 right 值
        rightFixedBoxHeight: 0,  // rightFixedBox 的高度
        showRightFixedBox: false,  // 是否显示 rightFixedBox
        whiteList: [],
        whiteHttpList: [],
    };
    componentDidMount() {
        const { app, user, thread, threadId, site } = this.props as any;
        // 首屏预取表情数据（站点级）
        // if (site && !site.hasEmoji && !site.isEmojiLoading && typeof site.fetchEmoji === 'function') {
        //     site.fetchEmoji();
        // }
        super.componentDidMount();
        this.calculateFormStatus();
        this.initWhiteList();
        // 每秒更新倒计时
        this.countdownInterval = setInterval(() => {
            this.calculateFormStatus();
        }, 1000);
        // 计算 rightFixedBox 的 right 值（延迟执行确保 DOM 已渲染）
        setTimeout(() => {
            this.initRightFixedBoxRight();
        }, 0);
        // 添加滚动监听
        window.addEventListener('scroll', this.handleScroll);
        // 添加窗口大小变化监听，重新计算 right 值
        window.addEventListener('resize', this.handleResize);
        // 版权保护：整个页面（含两侧空白）禁止右键
        if (isContentProtectionEnabled(thread?.threadData?.allowDownload)) {
            this.docContextMenuHandler = (e: MouseEvent) => e.preventDefault();
            document.addEventListener('contextmenu', this.docContextMenuHandler);
        }

    }

    componentDidUpdate() {
        // 版权保护：数据加载完成后补充 document 级别右键禁用（mount 时数据可能未就绪）
        const { thread } = this.props;
        if (isContentProtectionEnabled(thread?.threadData?.allowDownload) && !this.docContextMenuHandler) {
            this.docContextMenuHandler = (e: MouseEvent) => e.preventDefault();
            document.addEventListener('contextmenu', this.docContextMenuHandler);
        }
        // 当 rightFixedBoxRef 准备好且高度变化时，更新高度
        if (this.rightFixedBoxRef) {
            const newHeight = this.rightFixedBoxRef.offsetHeight;
            if (newHeight > 0 && newHeight !== this.state.rightFixedBoxHeight) {
                this.setState({ rightFixedBoxHeight: newHeight });
            }
        }
    }

    componentWillUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
        // 移除滚动监听
        window.removeEventListener('scroll', this.handleScroll);
        // 移除窗口大小变化监听
        window.removeEventListener('resize', this.handleResize);
        // 移除 document 级别的右键禁用
        if (this.docContextMenuHandler) {
            document.removeEventListener('contextmenu', this.docContextMenuHandler);
            this.docContextMenuHandler = null;
        }
    }

    // 滚动处理：当滚动距离 >= rightContentRef 的高度时显示 rightFixedBox
    handleScroll = () => {
        if (this.rightContentRef) {
            const rightContentHeight = this.rightContentRef.offsetHeight;
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            console.log('scrollTop', scrollTop, rightContentHeight);
            this.setState({ showRightFixedBox: scrollTop >= rightContentHeight });
        }
    }

    // 窗口大小变化处理：重新计算 rightFixedBox 的 right 值
    handleResize = () => {
        this.initRightFixedBoxRight();
    }

    private countdownInterval: any = null;  // 倒计时定时器

    // 初始化 rightFixedBox 的 right 值
    initRightFixedBoxRight = () => {
        // 直接用 rightContent 的实际位置计算
        if (this.rightContentRef) {
            const rect = this.rightContentRef.getBoundingClientRect();
            // 距离浏览器右侧的距离 = 可视宽度 - 元素的 right 坐标
            const viewportWidth = document.documentElement.clientWidth;
            const rightValue = viewportWidth - rect.right - 5;
            this.setState({
                rightFixedBoxRight: rightValue > 0 ? rightValue : 0
            });
        }
    }

    // 初始化 rightFixedBox 的高度
    initRightFixedBoxHeight = () => {
        if (this.rightFixedBoxRef) {
            const height = this.rightFixedBoxRef.offsetHeight;
            this.setState({
                rightFixedBoxHeight: height
            });
        }
    }

    // 初始化白名单
    initWhiteList = async () => {
        const { whiteList, whiteHttpList } = await getUrlWhitelist();
        this.setState({ whiteList, whiteHttpList });
    }

    // 计算表单状态和倒计时
    calculateFormStatus = () => {
        const { thread } = this.props;
        const threadData: any = thread?.threadData;

        if (!threadData?.hasForm || !threadData?.form) {
            return;
        }

        const form = threadData.form;
        const now = new Date().getTime();
        const startTime = form.startAt ? new Date(form.startAt).getTime() : now;
        const endTime = form.endAt ? new Date(form.endAt).getTime() : now;

        let status: 'notStarted' | 'ongoing' | 'ended' = 'notStarted';
        let countdown: any = '';

        if (now < startTime) {
            // 未开始
            status = 'notStarted';
            countdown = this.formatStartTime(form.startAt);
        } else if (now >= startTime && now < endTime) {
            // 进行中
            status = 'ongoing';
            countdown = this.formatCountdown(endTime - now);
        } else {
            // 已结束
            status = 'ended';
            countdown = this.formatStartTime(form.startAt);  // 已结束时显示开始时间
        }

        this.setState({
            formStatus: status,
            formCountdown: countdown
        });
    }

    // 格式化开始时间（智能显示年月日时分）
    formatStartTime = (startTime: string) => {
        if (!startTime) return null;
        try {
            const now = new Date();
            const date = new Date(startTime);

            if (isNaN(date.getTime())) {
                return null;
            }

            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            if (year !== now.getFullYear()) {
                return (
                    <span>
                        <span style={{ color: '#002A8D' }}>{year}</span>年
                        <span style={{ color: '#002A8D' }}>{month}</span>月
                        <span style={{ color: '#002A8D' }}>{day}</span>日
                        <span style={{ color: '#002A8D' }}>{hours}</span>时
                        <span style={{ color: '#002A8D' }}>{minutes}</span>分
                    </span>
                );
            }

            return (
                <span>
                    <span style={{ color: '#002A8D' }}>{month}</span>月
                    <span style={{ color: '#002A8D' }}>{day}</span>日
                    <span style={{ color: '#002A8D' }}>{hours}</span>时
                    <span style={{ color: '#002A8D' }}>{minutes}</span>分
                </span>
            );
        } catch (e) {
            console.error('格式化开始时间失败:', e);
            return null;
        }
    }


    // 格式化倒计时（显示为 X年X天X时X分 格式）
    formatCountdown = (ms: number) => {
        if (ms <= 0) return { text: '已结束', isEnded: true };

        // 计算年、天、时、分
        const totalDays = Math.floor(ms / (1000 * 60 * 60 * 24));
        const years = Math.floor(totalDays / 365);
        const days = totalDays % 365;
        const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));

        if (years > 0) {
            return { years, days, hours, minutes, isEnded: false };
        } else if (days > 0) {
            return { days, hours, minutes, isEnded: false };
        } else if (hours > 0) {
            return { hours, minutes, isEnded: false };
        } else {
            return { minutes, isEnded: false };
        }
    }

    private replaceEmojiInContent = (content?: string) => {
        return replaceEmojiCodes(content || '', this.props.site?.emojiList || []);
    };

    // 跳转到帖子详情页
    handleThreadClick = (item: any) => {
        // if(item.type == 3) {    // 是活动
        //     this.props.history && this.props.history.push(`/activityDetail/${item.id}`);
        // } else {    // 是其他
        //     this.props.history && this.props.history.push(`/threadDetail/${item.id}`);
        // }
        window.open(`/threadDetail/${item.id}`);
    };

    // 打开打赏弹框
    openRewardPopup = () => {
        this.setState({ rewardPopupStatus: true });
    };

    // 兼容删除确认弹框的回调（占位实现，按需接入真实删除逻辑）
    postsUpdate = () => {
        // 外面有接口方法
        this.closePopup();
    };

    // 点赞帖子、评论
    likeClick = async (data, type) => {
        const { thread, threadId } = this.props;
        const id = thread?.getId ? thread.getId(data) : data?.id;
        if (thread) {
            const params = {
                'id': id,
                'type': type,
                'isLiked': !data.isLiked,
                'likeCount': data.likeCount
            }
            await thread.createUserslikes(params);
        }
    }

    // likeClick 由父组件下发，移除此冗余方法
    // 关闭所有弹框
    closePopup = () => {
        // Toast.info('关闭')
        this.setState({
            deletePopupStatus: false,   // 删除弹框
            rewardPopupStatus: false,   // 打赏弹框
            reportPopupStatus: false,   // 举报弹框
            menuDropStatus: false,  //右上角下拉框
        })
    }
    // 确定打赏
    rewardConfirm = () => {
        let { rewardCheckValue } = this.state;
        if (rewardCheckValue == 0) {
            Toast.info('请选择打赏V币数');
            return false;
        }
        const { thread, threadId } = this.props;
        if (thread) {
            let params: any = {
                id: threadId,
                type: 0, // 0是主题
                scoreReward: rewardCheckValue,
                source: 'PC'
            }
            thread.postsCreate(params).then(res => {
                console.log(res, '结果');
                if (res.code === 0 || res.Code === 0) {
                    const data = res.data || res.Data;
                    if (data) {
                        // 将“打赏”评论插入评论列表顶部
                        thread.prependPostToList?.(data);
                        thread.getThreadDetail(threadId, {});
                    }
                    Toast.success({ content: '打赏成功' });
                } else {
                    Toast.info(res.msg || res.Message || '打赏失败');
                }
                this.setState({
                    rewardPopupStatus: false,   // 打赏弹框
                })
            })
        }
    }

    // 确定举报
    reportConfirm = () => {
        console.log('reportPopupStatusreportPopupStatus');
        let { threadId } = this.props;
        let { reportReason, reportType, reportCommentId } = this.state;
        if (reportReason == '') {
            Toast.info('请选择举报理由');
            return false;
        }
        const { thread } = this.props;
        if (thread) {
            let params: any = {
                id: reportType == 1 ? threadId : reportCommentId,
                type: reportType, // 0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
                reason: reportReason
            }
            thread.createReports(params).then(res => {
                this.setState({
                    reportPopupStatus: false,   // 举报弹框
                    menuDropStatus: false,  // 举报下拉框收起
                }, () => {
                    Toast.info('举报成功');
                })

            })
        }
    }
    // // 修改置顶时间
    // onChangeStickyAt = (date:any, dateString:any) => {
    //     console.log(date, dateString, '时间')
    //     this.setState({
    //         stickyAt: dateString
    //     })
    // }

    // // 设置置顶类型
    // setStickyType = (type: any) => {
    //     this.setState({
    //         stickyType: type
    //     })
    // }

    // 确定删除, type为帖子类型（普通帖、反馈、活动）；deleteType为删除类型（帖子、评论）
    // deletThreadConfirm = (type, deleteType) => {
    //     console.log()
    //     // const { thread, threadId } = this.props;
    //     // // 这里调用删除帖子的接口
    //     // if (thread) {
    //     //     let params: any = {
    //     //         status: !status,
    //     //         id: threadId
    //     //     }
    //     //     thread.createThreadOpera(params)
    //     // }
    //     this.setState({
    //         deletePopupStatus: false
    //     })
    // }

    // ===================== 表单相关方法 =====================
    // 获取表单信息
    onGetFormInfoList = async (isReadOnly: boolean = false) => {
        const { thread } = this.props;
        const threadData = thread?.threadData;

        if (!threadData?.hasForm) {
            return;
        }

        try {
            // 如果有已提交的缓存数据，优先使用缓存（不刷新页面再次打开时回显已填写内容）
            if (this.state.formSubmittedData && this.state.formSubmittedData.length > 0) {
                this.setState({
                    formInfo: this.state.formSubmittedData,
                    auditStatus: true,
                    consentStatus: true
                });
                return;
            }

            if (threadData?.form?.fields) {
                // 深拷贝字段数据，避免修改原始数据导致下次无法回显
                const fields = JSON.parse(JSON.stringify(threadData.form.fields));
                // 检查是否有任何已填写的数据
                let hasAnySubmittedValue = false;

                // 处理表单字段
                fields.forEach((field: any) => {
                    // 检查是否有之前填写的数据（注意：value为0也是有效值）
                    const hasSubmittedValue = field.value !== undefined && field.value !== null && field.value !== '';
                    if (hasSubmittedValue) {
                        hasAnySubmittedValue = true;
                    }

                    if (hasSubmittedValue) {
                        // 使用之前的值
                        if (field.type === 'checkbox') {
                            // 多选：value是逗号分隔的索引
                            const selectedIndices = String(field.value).split(',').filter(v => v).map(v => parseInt(v));
                            field.list = (field.options || []).map((option: any, index: number) => ({
                                label: getFormOptionText(option),
                                checked: selectedIndices.includes(index),
                                index: index
                            }));
                            // 保存为数组格式，与新填写时的onCheckBox逻辑保持一致
                            field.values = selectedIndices.map(i => i.toString());
                        } else if (field.type === 'radio') {
                            // 单选：value是索引
                            field.options = (field.options || []).map(getFormOptionText);
                            // 保持为数字格式，与 onRadioChange 逻辑一致
                            field.values = parseInt(field.value);
                        } else if (field.type === 'image') {
                            // 图片：value 可能是id(数字)或完整对象
                            // 如果是对象则直接用，如果是数字则只能保存id（服务器需要返回完整数据）
                            field.values = typeof field.value === 'object' ? field.value : field.value;
                        } else {
                            // 文本输入
                            field.values = field.value;
                        }
                    } else {
                        // 新填写的表单
                        field.values = null;

                        if (field.type === 'checkbox') {
                            // 多选框：生成 list 结构
                            field.list = (field.options || []).map((option: any, index: number) => ({
                                label: getFormOptionText(option),
                                checked: false,
                                index: index
                            }));
                        }

                        if (field.type === 'radio') {
                            // 单选框：统一提取选项文本，空内容不回退为对象。
                            field.options = (field.options || []).map(getFormOptionText);
                        }
                    }
                });

                // 如果有任何已填写的数据，自动进入只读模式
                const finalReadOnly = isReadOnly || hasAnySubmittedValue;

                if (!finalReadOnly) {
                    this.onCheckedFormStatus();
                }

                // 只读模式下保持原有的同意状态，新表单则重置
                this.setState({
                    formInfo: fields,
                    consentStatus: finalReadOnly ? this.state.consentStatus : false,
                    formCreateAt: new Date().toISOString(),
                    auditStatus: finalReadOnly
                });
            }
        } catch (error) {
            console.error('获取表单信息失败:', error);
        }
    }

    // 检查表单填写状态
    onCheckedFormStatus = () => {
        let { formInfo, consentStatus } = this.state;
        let status = true;

        formInfo.forEach((field: any) => {
            if ((field.values === null || field.values?.length === 0) && field.isRequired) {
                status = false;
            }
        });

        if (!consentStatus) {
            status = false;
        }

        this.setState({
            submitStatus: status
        });
    }

    // 多选框变化
    onCheckBox = (index: number, key: number) => {
        let { formInfo } = this.state;
        const selectList: any[] = [];

        formInfo[index].list[key].checked = !formInfo[index].list[key].checked;

        formInfo[index].list.forEach((v: any) => {
            if (v.checked) {
                selectList.push(v.index.toString());
            }
        });

        formInfo[index].values = selectList;

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 单选框变化
    onRadioChange = (k: number, key: any) => {
        let { formInfo } = this.state;
        formInfo[k].values = parseInt(key);

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 文本输入变化
    onWzNum = (key: number, value: string) => {
        let { formInfo } = this.state;
        formInfo[key].values = value;

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 打开文件选择对话框
    handleImageUploadClick = (fieldIndex: number) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) return;
            if (!file.type.startsWith('image/')) {
                Toast.info({ content: '请选择图片文件' });
                return;
            }
            const maxSize = 50 * 1024 * 1024;
            if (file.size > maxSize) {
                Toast.info({ content: '图片大小不能超过50MB' });
                return;
            }
            await this.uploadFormImage(file, fieldIndex);
        };
        input.click();
    }

    // 上传表单图片
    uploadFormImage = async (file: File, fieldIndex: number) => {
        try {
            const formData = new FormData();
            formData.append('type', '1');
            formData.append('file', file);
            const { uploadAttachment } = require('@server');
            const response = await uploadAttachment(formData);
            if (response.code === 0 && response.data?.id) {
                let { formInfo } = this.state;
                formInfo[fieldIndex].values = response.data;
                this.setState({ formInfo }, () => this.onCheckedFormStatus());
                Toast.success({ content: '图片上传成功' });
            } else {
                Toast.info({ content: response.message || '图片上传失败' });
            }
        } catch (error: any) {
            console.error('图片上传失败:', error);
            Toast.info({ content: '图片上传失败，请重试' });
        }
    }

    // 文件上传前处理
    uploadChange = (files: any[], item: any, key: number) => {
        if (files.length > 0) {
            return;
        }

        let { formInfo } = this.state;
        formInfo[key].values = files.length === 0 ? '' : files[0];

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 文件上传完成处理
    uploadComplete = (files: any[], i: number, key: number) => {
        let { formInfo } = this.state;
        // files是数组，取第一个元素的url
        if (files && files.length > 0 && files[0]?.url) {
            formInfo[key].values = files[0].url;
        }

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 文件上传移除
    uploadRemove = (files: any[], item: any) => {
        // 移除逻辑
    }

    // 提交表单
    onSendServer = (e: any) => {
        let { formInfo, submitStatus, formCreateAt } = this.state;
        const { thread, threadId } = this.props;
        const threadData: any = thread?.threadData;

        if (!submitStatus) {
            Toast.info({ content: '请填写完整信息!' });
            return false;
        }

        // 显示确认弹窗
        this.setState({ formSubmitConfirmVisible: true });
    }

    // 确认提交表单
    confirmSubmitForm = () => {
        let { formInfo, formCreateAt } = this.state;
        const { thread } = this.props;
        const threadData: any = thread?.threadData;
        this.setState({ formSubmitConfirmVisible: false });
        this.submitForm(formInfo, threadData, formCreateAt);
    }

    // 真正提交表单
    submitForm = (formInfo: any[], threadData: any, formCreateAt: string) => {
        const { thread } = this.props;

        const signUpInfo: any[] = [];
        formInfo?.forEach((field: any) => {
            if (field.type === 'checkbox') {
                // checkbox：没有选择则传空数组
                const value = field.values === null || field.values === undefined ? [] : field.values;
                signUpInfo.push({
                    id: field.id,
                    value: value
                });
            } else if (field.type === 'image') {
                // image：没有上传则传 0
                const value = field.values?.id ? field.values.id : 0;
                signUpInfo.push({
                    id: field.id,
                    value: value
                });
            } else if (field.type === 'radio') {
                // radio：没有选择且不是必填只传id不传value
                if ((field.values === null || field.values === undefined) && !field.isRequired) {
                    signUpInfo.push({
                        id: field.id
                    });
                } else {
                    const value = field.values === null || field.values === undefined ? '' : field.values;
                    signUpInfo.push({
                        id: field.id,
                        value: value
                    });
                }
            } else {
                // text 等其他类型：没有填写则传空字符串
                const value = field.values === null || field.values === undefined ? '' : field.values;
                signUpInfo.push({
                    id: field.id,
                    value: value
                });
            }
        });

        let params = {
            formId: threadData?.form?.id,
            signUpInfo: signUpInfo,
            time: formCreateAt
        };

        thread.createFormSubmit(params).then((res: any) => {
            if (res?.code === 0 || res?.Code === 0) {
                Toast.success({ content: '提交成功' });
                // 提交成功后，保存数据状态，以便不刷新页面重新点击已填写时能显示内容
                this.setState({
                    popupStatus: false,
                    auditStatus: true,  // 设置为只读模式
                    formSubmittedData: formInfo  // 保存已提交的表单数据
                });
            } else {
                Toast.info({ content: res?.msg || res?.Message || '提交失败' });
            }
        });
    }

    // 当前帖子用户信息
    threadUserInfo = () => {
        const { user, thread, createFollowUser, followDelete } = this.props;
        const { menuDropStatus } = this.state;
        const threadData: any = thread?.threadData;
        // console.log(user, '用户信息');
        const isSelf = (user?.userInfo as any)?.code && (user?.userInfo as any)?.code === threadData?.user?.code;
        return (
            <div className={styles.userInfoBox}>
                <Avatar
                    avatarUrl={threadData?.user?.avatar}
                    userCode={threadData?.user?.code}
                    officialSize={20}
                    titleMark={threadData?.user?.titleMark}
                    level={threadData?.user?.level}
                    data={threadData?.user}
                    size={50}
                    levelBadgeWidth={21}
                    levelBadgeHeight={14}
                ></Avatar>
                <div className={styles.infoBox}>
                    <div className={styles.infoDetail}>
                        <div className={styles.userNameBox}>
                            <div className={styles.userName}>{threadData?.user?.nickname}</div>
                            <div className={styles.userTitle}>{threadData?.user?.titleName}</div>
                        </div>
                        <div className={styles.userModel}>{threadData?.source}</div>
                    </div>
                    <div className={styles.userRight}>
                        {/* 作者自己不展示关注按钮 */}
                        {!isSelf && <>
                            {!threadData?.user?.isFollow && <div className={styles.followBtn} onClick={() => window.globalEnsureLogin(createFollowUser)}>关注</div>}
                            {threadData?.user?.isFollow && <div className={styles.followedBtn} onClick={() => window.globalEnsureLogin(followDelete)}>已关注</div>}
                        </>}
                        <div className={styles.menuBox}>
                            <div className={styles.menuIcon} onClick={() => {
                                this.setState({
                                    menuDropStatus: !menuDropStatus
                                })
                            }}></div>
                            {menuDropStatus && <div className={styles.menuDropListBox}>
                                <div className={styles.menuDropItem} onClick={() => window.globalEnsureLogin(() => {
                                    this.setState({
                                        reportPopupStatus: true,
                                        reportType: 1,
                                    });
                                })}>举报</div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // shareClick 由父组件下发，移除此冗余方法

    // 处理投票
    handleVoteClick = (option) => {
        // 调用父组件传递的函数
        const { createActivityVote } = this.props;
        if (createActivityVote) {
            createActivityVote(option);
        }
    }

    // 处理删除评论
    handleDeleteComment = async () => {
        console.log('删除评论')
        const { selectedCommentId } = this.state;
        if (!selectedCommentId) return;
        try {
            await this.props.postsUpdate?.(selectedCommentId, 'delete', 'comment');
            Toast.success({ content: '删除成功' });
            this.closeDeletePopup();
        } catch (error) {
            Toast.error({ content: '删除失败' });
        }
    }

    // 处理沉贴评论
    handleSinkComment = async () => {
        const { selectedCommentId, selectedCommentIsSink } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'sink', 'comment', selectedCommentIsSink);
            Toast.success({ content: selectedCommentIsSink ? '取消沉贴成功' : '沉贴成功' });
            this.closeMenuDropStatus();
        } catch (error) {
            Toast.error({ content: selectedCommentIsSink ? '取消沉贴失败' : '沉贴失败' });
        }
    }

    // 处理置顶评论
    handleStickyComment = async () => {
        const { selectedCommentId, selectedCommentIsSticky } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'sticky', 'comment', selectedCommentIsSticky);
            Toast.success({ content: selectedCommentIsSticky ? '取消置顶成功' : '置顶成功' });
            this.closeMenuDropStatus();
        } catch (error) {
            Toast.error({ content: selectedCommentIsSticky ? '取消置顶失败' : '置顶失败' });
        }
    }

    // 更新列表数据（已移至父组件 postsUpdate 方法中处理，此方法已废弃）
    updatePostList = (itemId: any, action: 'delete' | 'sink' | 'sticky') => {
        // MobX 数据更新现在在父组件 postsUpdate 中处理
    }

    // 关闭菜单下拉框
    closeMenuDropStatus = () => {
        this.setState({
            menuDropStatus: false,
            selectedCommentId: ''
        });
    }

    // 关闭删除弹框
    closeDeletePopup = () => {
        this.setState({
            deletePopupStatus: false,
            selectedCommentId: ''
        });
    }

    // 点击 @mention 跳转用户页
    handleMentionClick = (userId?: string) => {
        if (!userId) return;
        const { history } = this.props as any;
        if (history?.push) {
            history.push(`/user/${userId}`);
        }
    }

    // 帖子标签
    tagRender = (info) => {
        const tags: any = [];

        // 第一优先级标签, 规则 最多显示2个标签，第一个标签优先级：爆>热>顶>精>无；
        if (info?.isBoom) {
            tags.push({ img: `${BASE_IMG_URL}/common/fire.png`, alt: '爆款' });
        } else if (info?.isHot) {
            tags.push({ img: `${BASE_IMG_URL}/common/hot.png`, alt: '热门' });
        } else if (info?.isSticky != 0 || info?.showIndex === true) {
            tags.push({ img: `${BASE_IMG_URL}/common/stick.png`, alt: '置顶' });
        } else if (info?.isEssence) {
            tags.push({ img: `${BASE_IMG_URL}/common/essence.png`, alt: '精华' });
        } else if (info.isRecommend) {
            tags.push({ img: `${BASE_IMG_URL}/common/recommend.png`, alt: '推荐' });
        }

        // 赏标签（如果有）第二个标签优先级：赏>无
        if (info?.isReward) {
            tags.push({ img: `${BASE_IMG_URL}/common/reward.png`, alt: '有赏' });
        }

        if (tags.length === 0) {
            return null;
        }

        return (
            <>
                {tags.map((tag, index) => (
                    <img
                        key={index}
                        src={tag.img}
                        alt={tag.alt}
                        className={styles.postTag}
                        title={tag.alt}
                    />
                ))}
            </>
        );
    };

    // 过滤a标签白名单
    filterWhitelist = (content: string) => {
        const { whiteHttpList } = this.state || {}
        return cleanHttpLinks(content, whiteHttpList);
    };

    // 获取替换后的内容（用于图文帖）
    getReplacedContent = (content: string) => {
        const isProdEnv = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';   // 是否是生产环境
        // 替换 vivoclub 协议链接为 HTTPS 链接
        // return content.replace(
        //     /https?:\/\/?vivoclub:\/\/com\.vivo\.club[^"']*/g,
        //     isProdEnv ? 'https://club.vivo.com.cn/downloadAppEnter' : 'https://club-test.vivo.com.cn/downloadAppEnter'
        // );
        return content.replace(
            /(?:https?:\/\/)?vivoclub:\/\/com\.vivo\.club[^"'<>()\s]*/g,
            isProdEnv ? 'https://club.vivo.com.cn/downloadAppEnter' : 'https://club.vivo.com.cn/downloadAppEnter'
        );
    };

    // 创建包含标签的内容
    createContentWithTags = () => {
        const { thread } = this.props;
        const threadData: any = thread?.threadData;
        const type = thread?.threadData?.type;
        if (!threadData?.content) return '';

        const tagsHtml = this.tagRender(threadData);

        const tagsString = tagsHtml ? `
            <span style="
                display: inline-block;
                vertical-align: top;
                margin-right: 6px;
                line-height: 1.5;
                white-space: nowrap;
            ">
                ${tagsHtml.props.children.map((child: any, index: number) =>
            `<img 
                        key="${index}"
                        src="${child.props.src}" 
                        alt="${child.props.alt}" 
                        class="${child.props.className}" 
                        title="${child.props.title}"
                        style="display: inline-block; vertical-align: middle; margin-right: 2px;"
                    />`
        ).join('')}
            </span>
        ` : '';

        let content;
        if ([1, 3].includes(Number(type))) {
            // 处理换行符：将 \n 替换为 <br>
            const processedContent = threadData.content
                .replace(/\r\n/g, '<br>')  // Windows 换行
                .replace(/\n/g, '<br>');   // Unix/Linux 换行

            content = `
                <div style="
                    line-height: 1.5;
                    word-break: break-word;
                ">
                    ${tagsString}
                    <span style="display: inline;">
                        ${processedContent}
                    </span>
                </div>
            `;
        } else if (type == 2) {
            // 图文转反馈后，接口已将标题合入正文；只展示接口正文和反馈状态。
            const statusInfo = getFeedbackStatus(threadData?.feedback?.solveState);
            let processedContent = threadData.content
                .replace(/\r\n/g, '<br>')
                .replace(/\n/g, '<br>');
            if (statusInfo) {
                processedContent = `<span class="${styles.feedbackStatus} ${styles[statusInfo.style]}">${statusInfo.text}</span>${processedContent}`;
            }
            content = processedContent;
        } else {
            // 非微帖：同样处理换行符
            const processedContent = threadData.content
                .replace(/\r\n/g, '<br>')  // Windows 换行
                .replace(/\n/g, '<br>');   // Unix/Linux 换行

            content = `
                <div style="
                    line-height: 1.5;
                    word-break: break-word;
                ">
                    <span style="display: inline;">
                        ${processedContent}
                    </span>
                </div>
            `;
        }

        content = this.filterWhitelist(content);
        content = this.getReplacedContent(content);
        return content;
    };

    // 轮播图change事件
    // handleSlideChange = (swiper: any) => {
    //     this.setState({
    //         swiperActiveIndex: swiper.activeIndex
    //     })

    // };

    private swiperInstance: any = null; // Swiper 实例引用

    // 设置 Swiper 实例
    setSwiperInstance = (swiper: any) => {
        this.swiperInstance = swiper;
    }

    // 下一张图片
    handleNext = (e: React.MouseEvent) => {
        e.stopPropagation(); // 阻止事件冒泡
        if (this.swiperInstance) {
            this.swiperInstance.slideNext();
        }
    }

    // 上一张图片
    handlePrev = (e: React.MouseEvent) => {
        console.log('上一张');
        e.stopPropagation(); // 阻止事件冒泡
        if (this.swiperInstance) {
            this.swiperInstance.slidePrev();
        }
    }

    // 轮播图切换事件
    handleSlideChange = (swiper: any) => {
        console.log('下一张');
        // 切换时暂停所有live视频
        this.pauseAllLiveVideos();
        this.setState({
            swiperActiveIndex: swiper.activeIndex
        });
    }

    // 暂停所有live视频
    pauseAllLiveVideos = () => {
        this.liveVideoRefs.forEach((video) => {
            if (video && !video.paused) {
                video.pause();
            }
        });
        this.setState({ livePlayingIndex: null });
    }

    // 点击live图播放
    handleLiveClick = (index: number, liveUrl: string) => {
        const currentIndex = typeof this.swiperInstance?.activeIndex === 'number' ? this.swiperInstance.activeIndex : index;
        const currentLiveUrl = this.props.thread?.threadData?.images?.[currentIndex]?.liveUrl || liveUrl;
        const { livePlayingIndex } = this.state;
        // 如果已在播放，暂停
        if (livePlayingIndex === currentIndex) {
            const video = this.liveVideoRefs.get(currentIndex);
            if (video) {
                video.pause();
            }
            this.setState({ livePlayingIndex: null });
            return;
        }
        // 暂停其他视频
        this.pauseAllLiveVideos();
        const video = this.liveVideoRefs.get(currentIndex);
        if (video) {
            if (currentLiveUrl && video.src !== currentLiveUrl) {
                video.src = currentLiveUrl;
                video.load();
            }
            video.currentTime = 0;
            video.muted = this.state.liveMuted;
            video.play().then(() => {
                this.setState({ livePlayingIndex: currentIndex });
            }).catch(() => {});
        }
    }

    // live视频播放结束
    handleLiveVideoEnded = (index: number) => {
        this.setState({ livePlayingIndex: null });
    }

    // 切换live图静音
    toggleLiveMute = (e: React.MouseEvent) => {
        e.stopPropagation();
        const newMuted = !this.state.liveMuted;
        this.setState({ liveMuted: newMuted });
        const { livePlayingIndex } = this.state;
        if (livePlayingIndex !== null) {
            const video = this.liveVideoRefs.get(livePlayingIndex);
            if (video) {
                video.muted = newMuted;
            }
        }
    }

    // 设置live视频ref
    setLiveVideoRef = (index: number, el: HTMLVideoElement | null) => {
        if (el) {
            this.liveVideoRefs.set(index, el);
        } else {
            this.liveVideoRefs.delete(index);
        }
    }

    // 首页左侧侧内容
    readerLeft = () => {
        const { thread, createActivityVote, user, isVivoBrowserStatus, satisfactionLevel } = this.props;
        let { rewardPopupStatus, rewardCheckValue, reportPopupStatus, reportReasonList, menuDropStatus, deletePopupStatus, swiperActiveIndex, selectedCommentId, livePlayingIndex, liveMuted } = this.state;
        if (!thread) { return null }
        const threadData: any = thread.threadData;
        const presentation = getThreadPresentation(threadData || {});
        const isProtected = isContentProtectionEnabled(threadData?.allowDownload);
        const protectedMediaHandlers = getProtectedEventHandlers(isProtected);
        const pageProtectionProps = isProtected
            ? {
                ...protectedMediaHandlers,
                style: protectedMediaStyle,
            }
            : {};
        let options = {};
        const isSelf = (user?.userInfo as any)?.code && (user?.userInfo as any)?.code === threadData?.user?.code;
        console.log(selectedCommentId, '当前选中的评论Id');
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
                if (domNode.name === 'img') {
                    // 反馈附件统一在轮播或视频区展示；保留正文表情和原始附件数据。
                    const isEmojiImage = Boolean(domNode.attribs?.['data-emoji']) || domNode.attribs?.class?.includes(styles.emojiInlineLarge);
                    if (presentation.hideInlineImages && !isEmojiImage) {
                        return <></>;
                    }
                    // return (
                    // <img
                    //     {...domNode.attribs}
                    //     loading="lazy"
                    //     onError={(e) => {
                    //     e.currentTarget.style.display = 'none';
                    //     }}
                    // />
                    // );
                }
                if (domNode.name === 'span' && domNode.attribs?.class?.includes('member') && domNode.attribs['data-code']) {
                    const userId = domNode.attribs['data-code'];
                    const styleAttr = domNode.attribs.style || '';
                    const firstChild = domNode.children?.[0];
                    const childStyleAttr = firstChild?.attribs?.style || '';
                    const colorSource = childStyleAttr || styleAttr;
                    const colorMatch = colorSource.match(/color\s*:\s*([^;]+)/i);
                    const mentionText = (domNode.children || []).map((child: any) => child?.data || child?.children?.[0]?.data || '').join('').trim() || domNode.children?.[0]?.children?.[0]?.data || '';

                    // 判断是否是当前用户
                    const isCurrentUser = userId === user.userInfo?.code;

                    const style: React.CSSProperties = {
                        cursor: 'pointer',
                        display: 'inline-block',
                        padding: '0 8px',
                        height: '26px',
                        lineHeight: '26px',
                        // background: 'rgba(30, 70, 230,0.05)',
                        // borderRadius: '30px',
                        // margin: '0 4px',
                        color: '#002A8D',
                        ...(colorMatch ? { color: colorMatch[1].trim() } : {}),
                        // 如果是当前用户，覆盖背景色和字体颜色
                        ...(isCurrentUser ? {
                            backgroundColor: '#002A8D',
                            borderRadius: '30px',
                            color: 'white',
                        } : {})
                    };

                    return (
                        <span
                            className={domNode.attribs.class}
                            style={style}
                            onClick={() => this.handleMentionClick(userId)}
                        >
                            {mentionText}
                        </span>
                    );
                }
            },
            ...options
        };
        // 创建包含标签的内容
        const contentWithTags = this.createContentWithTags();
        const lottery:any = threadData?.lotteryActivities?.length > 0 ? threadData?.lotteryActivities?.[0] : {};
        console.log(threadData, '详情');
        return (
            <div className={styles.leftContent}>
                {!threadData?.id ? <div className={styles.loadingBox}>
                    <img src={`${BASE_IMG_URL}/common/loading.png`} alt="" className={styles.loadingIcon}/>
                    <div className={styles.loadingText}>正在加载...</div>
                </div>: <>
                    {/* 如果帖子未删除，有查看权限或者是作者本人 */}
                    {<div className={classNames(styles.detailBox, presentation.isFeedback && styles.feedbackThread)}>
                        {threadData?.isPrivate && <div className={classNames(styles.examine, styles.examineError)}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon6.png`} />
                                <div className={styles.tipsText}>经系统判断该帖存在质量问题，仅自己可见</div>
                            </div>
                        </div>}

                        {threadData?.isApproved == 2 &&
                            <div className={classNames(styles.examine, styles.examineError)}>
                                <div className={styles.innerTip}>
                                    <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon6.png`} />
                                    <span className={styles.tipsText} onClick={() => this.props.history && this.props.history.push('/selfDiscipline')} style={{ cursor: 'pointer' }}>审核不通过，vivo社区提醒您发帖请遵守社区公约</span>
                                </div>
                            </div>
                        }

                        {(threadData?.isHidden && threadData?.isApproved == 1) &&
                            <div className={classNames(styles.examine, styles.examineHidden)}>
                                <div className={styles.innerTip}>
                                    <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/eyes.png`} />
                                    <span className={styles.tipsText}>{isSelf ? '仅自己可见' : '仅作者可见'}</span>
                                </div>
                            </div>
                        }

                        {(!threadData?.isDisplay && threadData?.isApproved == 1 && user?.userInfo?.group?.isAdmin) &&
                            <div className={classNames(styles.examine, styles.examineHidden)}>
                                <div className={styles.innerTip}>
                                    <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/eyes.png`} />
                                    <span className={styles.tipsText}>已屏蔽</span>
                                </div>
                            </div>
                        }

                        {(threadData?.isSink && threadData?.isApproved == 1 && user?.userInfo?.group?.isAdmin) &&
                            <div className={classNames(styles.examine, styles.examineHidden)}>
                                <div className={styles.innerTip}>
                                    <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/thread_sink.png`} />
                                    <span className={styles.tipsText}>已沉帖</span>
                                </div>
                            </div>
                        }
                        {threadData?.deletedAt &&
                            <div className={classNames(styles.examine, styles.examineError)}>
                                <div className={styles.innerTip}>
                                    <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon6.png`} />
                                    <span className={styles.tipsText} onClick={() => this.props.history && this.props.history.push('/selfDiscipline')} style={{ cursor: 'pointer' }}>帖子已删除</span>
                                </div>
                            </div>
                        }

                        {/* 定时发布标识 */}
                        {threadData?.fixedAt && (
                            <div className={styles.fixedAtBoxContainer}>
                                <div className={styles.fixedAtBox}>
                                    <img
                                        src={setPostImage.fixedAtIcon}
                                        alt="定时发布"
                                        className={styles.fixedAtIcon}
                                    />
                                    <span className={styles.fixedAtLabel}>定时发布：</span>
                                    <span className={styles.fixedAtTime}>
                                        {(() => {
                                            const date = new Date(threadData.fixedAt);
                                            const year = date.getFullYear();
                                            const month = String(date.getMonth() + 1).padStart(2, '0');
                                            const day = String(date.getDate()).padStart(2, '0');
                                            const hour = String(date.getHours()).padStart(2, '0');
                                            const minute = String(date.getMinutes()).padStart(2, '0');
                                            return (
                                                <>
                                                    <span className={styles.fixedAtNum}>{year}</span> 年{' '}
                                                    <span className={styles.fixedAtNum}>{month}</span> 月{' '}
                                                    <span className={styles.fixedAtNum}>{day}</span> 日{' '}
                                                    <span className={styles.fixedAtNum}>{hour}</span> 时{' '}
                                                    <span className={styles.fixedAtNum}>{minute}</span> 分
                                                </>
                                            );
                                        })()}
                                    </span>
                                </div>
                                {threadData?.isApproved == 0 && (
                                    <div className={classNames(styles.examine, styles.examineInline)}>
                                        <div className={styles.innerTip}>
                                            <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon5.png`} />
                                            <span className={styles.tipsText}>帖子审核中</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {threadData?.isApproved == 0 && !threadData?.fixedAt &&
                            <div className={styles.examine}>
                                <div className={styles.innerTip}>
                                    <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon5.png`} />
                                    <span className={styles.tipsText}>帖子审核中</span>
                                </div>
                            </div>
                        }

                        {!presentation.isFeedback && (Number(threadData?.type) !== 3 || threadData?.topics?.length > 0) && <div className={styles.titleOutBox}>
                            {/* 帖子标题 */}
                            <div className={styles.titleBox}>
                                {threadData?.type == 0 && this.tagRender(threadData)}
                                {/* {threadData?.isBoom && <img src={`${BASE_IMG_URL}/common/fire.png`} alt="" className={styles.postTag} />}
                                {threadData?.isHot && <img src={`${BASE_IMG_URL}/common/hot.png`} alt="" className={styles.postTag} />}
                                {threadData?.isSticky != 0 && <img src={`${BASE_IMG_URL}/common/stick.png`} alt="" className={styles.postTag} />}
                                {threadData?.isEssence != 0 && <img src={`${BASE_IMG_URL}/common/essence.png`} alt="" className={styles.postTag} />} */}
                                {/* {threadData?.isReward && <img src={`${BASE_IMG_URL}/common/reward.png`} alt="" className={styles.postTag} />} */}
                                {Number(threadData?.type) !== 3 && threadData?.title}
                                {threadData?.topics?.map((topic: any, idx: number) => (
                                    <span key={topic?.id ?? `topic-${idx}`} className={styles.topicName} onClick={() => {
                                        this.props.history && this.props.history.push(`/topicDetail/${topic.id}`);
                                    }}>{topic.name}</span>
                                ))}
                            </div>

                        </div>}
                        {/* 帖子作者 */}
                        {this.threadUserInfo()}

                        {presentation.showImages && <div className={styles.imagesListBox}>
                            <Swiper
                                modules={[Pagination, Autoplay]}
                                autoplay={false} // 禁用自动轮播
                                loop={false}
                                onSwiper={this.setSwiperInstance}
                                onSlideChange={(e) => this.handleSlideChange(e)}
                            >
                                {threadData?.images?.map((img: any, index: any) => (
                                    <SwiperSlide key={img.id}>
                                        <div key={img.id} className={styles.imagesItemBox}
                                            {...protectedMediaHandlers}
                                            onClick={() => {
                                                if (img.isLive && img.liveUrl && swiperActiveIndex === index) {
                                                    this.handleLiveClick(index, img.liveUrl);
                                                }
                                            }}
                                        >
                                            {/* Live 图：视频 + 封面图 */}
                                            {img.isLive && img.liveUrl ? (
                                                <>
                                                    <video
                                                        ref={(el) => {
                                                            this.setLiveVideoRef(index, el);
                                                        }}
                                                        src={img.liveUrl}
                                                        style={{
                                                            width: '814px',
                                                            height: '610px',
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            objectFit: 'contain',
                                                            ...(isProtected ? protectedMediaStyle : {})
                                                        }}
                                                        playsInline
                                                        loop={false}
                                                        muted={liveMuted}
                                                        onEnded={() => this.handleLiveVideoEnded(index)}
                                                        poster={img.webpUrl || updateImageListSrc(img.url, 7)}
                                                    />
                                                    {/* 视频未播放时显示封面图 */}
                                                    {livePlayingIndex !== index && (
                                                        <img
                                                            src={img.webpUrl || updateImageListSrc(img.url, 7)}
                                                            style={{
                                                                position: 'absolute',
                                                                width: '814px',
                                                                height: '610px',
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer',
                                                                ...(isProtected ? protectedMediaStyle : {})
                                                            }}
                                                            alt=""
                                                        />
                                                    )}
                                                </>
                                            ) : (
                                                <Image
                                                    src={img.webpUrl || updateImageListSrc(img.url, 7)}
                                                    style={{
                                                        width: '814px',
                                                        height: '610px',
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        objectFit: 'contain',
                                                        ...(isProtected ? protectedMediaStyle : {})
                                                    }}
                                                    height={610}
                                                    width={814}
                                                    fallback={`${BASE_IMG_URL}/common/pic_place1.png`}
                                                    preview={{ mask: '' }}
                                                />
                                            )}
                                            {/* Live 图标识 */}
                                            {img.isLive && img.liveUrl && (
                                                <div className={styles.liveIndicator}>
                                                    <div className={styles.liveTag} style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); this.handleLiveClick(index, img.liveUrl); }}>
                                                        <img className={styles.liveIcon} src={livePhotoImage.liveIcon} alt="" />
                                                        <span>动态照片</span>
                                                    </div>
                                                    <div className={styles.soundTag} onClick={this.toggleLiveMute}>
                                                        <img className={styles.soundIcon} src={liveMuted ? livePhotoImage.volumeClose : livePhotoImage.volume} alt="" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </SwiperSlide>
                                ))}
                                {/* 添加导航箭头 */}
                                <div className={styles.swiperPrev} onClick={this.handlePrev}></div>
                                <div className={styles.swiperNext} onClick={this.handleNext}></div>
                            </Swiper>
                            {/* 自定义分页指示器 */}
                            <div className={styles.customPagination1}>
                                <div className={`swiper-pagination ${styles.customPagination}`}></div>
                                <div className={styles.paginationInfo}>
                                    <span className={styles.currentIndex}>{swiperActiveIndex + 1}</span>
                                    <span className={styles.slash}>/</span>
                                    <span className={styles.totalCount}>{threadData?.images?.length}</span>
                                </div>
                            </div>

                            <div className={styles.customPagination2}>
                                {threadData?.images?.map((img: any, index: any) => (
                                    <div key={index} className={classNames(styles.pageItem, swiperActiveIndex == index ? styles.swiperActive : '')}></div>
                                ))}
                            </div>
                        </div>}

                        <div className={styles.threadContentBox}>
                            {presentation.videoBeforeContent && (
                                <ThreadDetailVideo key={threadData.video.url} src={threadData.video.url} poster={threadData.video.videoCoverUrl} isProtected={isProtected} beforeContent />
                            )}
                            <div className={styles.richeText}>
                                {threadData?.content != '' && <>
                                    {Number(threadData?.type) === 2 ? <div className={styles.feedbackContent}>
                                        {parse(this.replaceEmojiInContent(contentWithTags), parserOptions)}
                                    </div> : parse(this.replaceEmojiInContent(contentWithTags || ''), parserOptions)}
                                </>}
                            </div>

                            {/* 问题反馈信息 */}
                            {threadData?.type == 2 && <div className={styles.feedbackDetailBox}>
                                <div className={styles.feedbackInfo}><span>问题类型：</span>{threadData?.feedback?.problem?.name}</div>
                                <div className={styles.feedbackInfo}><span>手机型号：</span>{presentation.feedbackProductName}</div>
                                <div className={styles.feedbackInfo}><span>软件版本号：</span>{presentation.feedbackSystemVersion}</div>
                                {(isSelf || user?.userInfo?.group?.isAdmin) && threadData?.feedback?.imei && <div className={styles.feedbackInfo}><span>IMEI1号：</span>{threadData?.feedback?.imei}（仅官方可见）</div>}
                                {(isSelf || user?.userInfo?.group?.isAdmin) && threadData?.feedback?.logCode && <div className={styles.feedbackInfo}><span>操作日志：</span>{threadData?.feedback?.logCode}（仅官方可见）</div>}
                                {(isSelf || user?.userInfo?.group?.isAdmin) && threadData?.feedback?.phone && <div className={styles.feedbackInfo}><span>联系电话：</span>{threadData?.feedback?.phone}（仅官方可见）</div>}
                            </div>}

                            {presentation.videoAfterContent && (
                                <ThreadDetailVideo key={threadData.video.url} src={threadData.video.url} poster={threadData.video.videoCoverUrl} isProtected={isProtected} />
                            )}

                            {/* 投票 */}
                            <div className={styles.voteBox}>
                                <VoteList threadData={threadData} votesData={threadData?.votes} onSubmit={(option) => this.handleVoteClick(option)} hasVoted={threadData?.votes?.[0]?.isVoted} />
                            </div>
                            {/* 帖子合集 */}
                            {threadData?.collection?.length > 0 && <div className={styles.collectionList}>
                                {threadData?.collection?.map((item: any, idx: number) => (
                                    <div key={item?.id ?? `collection-${idx}`} className={styles.collectionItem}>
                                        {item.coverUrl !== '' && <img src={item.coverUrl} alt="帖子合集" className={styles.collectionCover} onClick={() => this.handleThreadClick(item)} />}
                                        <div className={styles.collectionDetail}>
                                            <div className={styles.collectionTitle} onClick={() => this.handleThreadClick(item)}>{item.title || item.summary}</div>
                                            <div className={styles.collectionInfo}>
                                                <div className={styles.collectionUserBox}>
                                                    <Avatar avatarUrl={item.user?.avatar} officialSize={10} titleMark={item.user?.titleMark} data={item.user} size={22}></Avatar>
                                                    <div className={styles.name}>{item.user?.nickname}</div>
                                                </div>
                                                <div className={styles.infoOperaBox} onClick={() => this.handleThreadClick(item)}>
                                                    <div className={styles.operaItem}>
                                                        <img src={`${BASE_IMG_URL}/common/comment.png`} alt="" className={styles.icon} />
                                                        <div className={styles.count}>{item.postCount}</div>
                                                    </div>
                                                    <div className={styles.operaItem} onClick={() =>
                                                        window.globalEnsureLogin(() => {
                                                            this.handleThreadClick(item)
                                                        })}>
                                                        <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon} />
                                                        <div className={styles.count}>{item.likeCount}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>}
                        </div>

                        {/* 表单入口 */}
                        {threadData?.hasForm && <div className={styles.formEntryBox} onClick={() => {
                            if (!this.props.user?.userInfo?.id) {
                                const { user } = this.props as any;
                                if (user && typeof user.checkLogin === 'function') {
                                    const isLogin = user.checkLogin();
                                    if (!isLogin) {
                                        console.log('[SetPost] User not logged in, aborting init (checkLogin handled redirect)');
                                        return;
                                    }
                                }
                                Toast.info({ content: '请先登录!' });
                                return;
                            }

                            // 规则1：未开始 - 不支持打开，提示"活动未开始"
                            if (this.state.formStatus === 'notStarted') {
                                Toast.info({ content: '活动未开始' });
                                return;
                            }

                            // 规则3：未填写且已结束 - 不支持打开，提示"活动已结束"
                            if (this.state.formStatus === 'ended' && !threadData?.form?.isSubmitted) {
                                Toast.info({ content: '活动已结束' });
                                return;
                            }

                            // 规则2：已填写 - 支持打开查看，进行中可编辑，已结束只读
                            // 当form.isSubmitted=true时，传入isReadOnly标识。只读模式由onGetFormInfoList内部根据是否有数据判断
                            const isReadOnly = threadData?.form?.isSubmitted && this.state.formStatus === 'ended';

                            this.onGetFormInfoList(isReadOnly);
                            this.setState({ popupStatus: true });
                        }}>
                            <div className={styles.formIcon}></div>
                            <div className={styles.formContent}>
                                <div className={styles.formTitle}>{threadData?.form?.name || '表单'}</div>
                                <div className={styles.formMeta}>
                                    {this.state.formStatus === 'notStarted' ? (
                                        // 未开始：显示开始时间
                                        <span>开始时间：{this.state.formCountdown}</span>
                                    ) : this.state.formStatus === 'ongoing' ? (
                                        // 进行中：显示参与人数和倒计时
                                        <>
                                            {(threadData?.form?.userCount || 0) > 0 && <span>已有<span className={styles.highlight}>{threadData?.form?.userCount}</span>人参与</span>}
                                            <span className={styles.countdown}>
                                                距结束：
                                                {(this.state.formCountdown as any)?.isEnded ? (
                                                    <span>{(this.state.formCountdown as any).text}</span>
                                                ) : (
                                                    <>
                                                        {(this.state.formCountdown as any)?.days && <><span className={styles.countdownNumber}>{(this.state.formCountdown as any).days}</span><span>天</span></>}
                                                        {(this.state.formCountdown as any)?.hours !== undefined && <><span className={styles.countdownNumber}>{(this.state.formCountdown as any).hours}</span><span>时</span></>}
                                                        {(this.state.formCountdown as any)?.minutes !== undefined && <><span className={styles.countdownNumber}>{(this.state.formCountdown as any).minutes}</span><span>分</span></>}
                                                    </>
                                                )}
                                            </span>
                                        </>
                                    ) : (
                                        // 已结束：只显示参与人数（当参与人数>0时）
                                        (threadData?.form?.userCount || 0) > 0 ? (
                                            <span>已有<span className={styles.highlight}>{threadData?.form?.userCount}</span>人参与</span>
                                        ) : null
                                    )}
                                </div>
                                <div className={styles.formBtnWrap}>
                                    {this.state.formStatus === 'notStarted' && (
                                        <span className={styles.startBtn}>即将开始</span>
                                    )}
                                    {this.state.formStatus === 'ongoing' && (
                                        threadData?.form?.isSubmitted ? (
                                            <span className={styles.filledBtn}>已填写</span>
                                        ) : (
                                            <span className={styles.filledBtn}>点击填写</span>
                                        )
                                    )}
                                    {this.state.formStatus === 'ended' && (
                                        <span className={styles.endedBtn}>已结束</span>
                                    )}
                                </div>
                            </div>
                        </div>}


                        {/* 抽奖入口 */}
                        {lottery && lottery?.length !== 0 && JSON.stringify(lottery) !== '{}' &&
                        <div id="lotteryEnter" className={styles.entryAuto} onClick={() => {
                            this.props.history && this.props.history.push(`/lottery/${lottery?.code}`);
                        }}>
                            <div className={styles.lotteryIconBox}>
                                <div className={styles.lotteryTip}><img src={`${BASE_IMG_URL}/lottery/icon9.png`} className={styles.icon}/>抽奖</div>
                                <img src={lottery?.coverUrl} className={styles.lotteryIcon}/>
                            </div>

                            <div className={styles.lotteryInfo}>
                                <div className={styles.lotteryName}>{lottery?.name}</div>
                                {(lottery?.status == 0 || lottery?.status == 1) && <div className={styles.lotteryTime}>{lottery?.status == 0 ? '距开始：' :'距结束：'}<CountDown number={lottery?.status == 0 ? new Date(lottery.startAt).getTime() : new Date(lottery.endAt).getTime()} endText='&nbsp;' itemStylesData={{background: 'transparent',color: lottery.foregroundColor,padding: '0', height: px2rem(32), lineHeight: px2rem(32)}} boxStylesData={{justifyContent:'center', color:'#939598'}}/></div>}
                                {lottery?.status == 3 && <div className={styles.lotteryUserNum}>已有<span>{lottery?.lotteryUsers}</span>人参与</div>}

                                {/* 抽奖按钮 */}
                                {lottery?.status == 0 &&
                                    <div className={classNames(styles.lotteryBtn,styles.lotteryBtn1)}>
                                        即将开始
                                    </div>
                                }
                                {lottery?.status == 1 &&
                                    <div className={classNames(styles.lotteryBtn,styles.lotteryBtn2)}>
                                        去抽奖
                                    </div>
                                }
                                {lottery?.status == 3 &&
                                <div className={classNames(styles.lotteryBtn,styles.lotteryBtn3)}>
                                    已结束
                                </div>
                                }
                            </div>
                        </div>}

                        <div className={styles.threadBottomInfoBox}>
                            <div className={styles.threadBottomInfoLeft}>
                                {/* AI声明 */}
                                {threadData?.aigcStatus != 0 && (
                                    <div className={styles.aiTagBox}>
                                        <img
                                            src={setPostImage.aiIcon}
                                            alt="AI生成"
                                            className={styles.aiIcon}
                                        />
                                        {threadData?.aigcStatus == 2 && <span className={styles.aiText}>{threadData?.isAigc ? '作者声明：内容含AI生成元素' : '内容可能含AI生成元素'}</span>}
                                        {threadData?.aigcStatus == 1 && <span className={styles.aiText}>内容含AI生成元素</span>}
                                        {threadData?.aigcStatus == 3 && <span className={styles.aiText}>内容含疑似AI生成元素</span>}
                                    </div>
                                )}

                                <div className={styles.threadBottomInfo}>
                                    <div className={styles.postTime}>{formatTime(threadData?.createdAt)}</div>
                                    {threadData?.source && <div className={styles.postArea}>{threadData?.source}</div>}
                                    {threadData?.ipRegion && <div className={styles.postArea}>{threadData?.ipRegion}</div>}
                                </div>

                                {!isSelf && threadData?.type == 2 && <div className={classNames(styles.feedbackSame, threadData?.feedback?.isSame ? styles.feedbackSameGray : '')} onClick={() => window.globalEnsureLogin(() => this.props.submitFeedbackSame?.())}>{!threadData?.feedback?.isSame ? '我也遇到了相同问题' : '反馈成功'}</div>}
                            </div>
                            {(isSelf || user?.userInfo?.group?.isAdmin) && <div className={styles.viewCount}>{formatNumberToWan(threadData?.viewCount)}</div>}
                        </div>
                        <div className={styles.rewardBtn} onClick={() => window.globalEnsureLogin(() => this.openRewardPopup())}>
                            <img src={`${BASE_IMG_URL}/common/icon14.png`} alt="" className={styles.rewardIcon} />
                            <span className={styles.rewardText}>打赏</span>
                        </div>
                        {(threadData?.lastRewardedUsers && threadData?.lastRewardedUsers.length > 0) && <div className={styles.rewardUserList}>
                            <AvatarList userList={threadData?.lastRewardedUsers} size={18}></AvatarList>
                            <div className={styles.text}>{threadData?.rewardedCount}人已打赏</div>
                        </div>}

                        <div className={styles.operaCountList}>
                            <div className={styles.operaCountItem} onClick={() => window.globalEnsureLogin(() => this.props.likeClick?.(threadData, 'thread'))}>
                                <img src={threadData?.isLiked ? `${BASE_IMG_URL}/common/liked.png` : `${BASE_IMG_URL}/common/like2.png`} alt="" className={styles.operaIcon} />
                                <div className={classNames(styles.operaCount, threadData?.isLiked ? styles.likeCountActive : '')}>{threadData?.likeCount || '点赞'}</div>
                            </div>
                            <div className={styles.operaCountItem} onClick={() => window.globalEnsureLogin(() => this.props.favoriteClick?.(threadData?.isFavorite))}>
                                <img src={threadData?.isFavorite ? `${BASE_IMG_URL}/common/favorited.png` : `${BASE_IMG_URL}/common/favorite2.png`} alt="" className={styles.operaIcon} />
                                <div className={classNames(styles.operaCount, threadData?.isFavorite ? styles.favoriteCountActive : '')}>{threadData?.favoriteCount || '收藏'}</div>
                            </div>
                            <div className={styles.operaCountItem}>
                                <img src={`${BASE_IMG_URL}/common/comment2.png`} alt="" className={styles.operaIcon} />
                                <div className={styles.operaCount}>{threadData?.postCount || '评论'}</div>
                            </div>
                            <div className={styles.operaCountItem} onClick={() => this.props.shareClick?.()}>
                                <img src={`${BASE_IMG_URL}/common/share3.png`} alt="" className={styles.operaIcon} />
                                <div className={styles.operaCount}>{threadData?.shareCount || '转发'}</div>
                            </div>
                        </div>
                    </div>}
                    {/* 打赏弹框 */}
                    <CommonPopup
                        visible={rewardPopupStatus}
                        title='支持作者继续创作'
                        onCancelChange={() => this.closePopup()}
                        onConfirmButtonChange={() => this.rewardConfirm()}
                    >
                        {/* children 插槽内容 */}
                        <div className={styles.rewardListBox}>
                            {threadData?.rewardScoreList?.map((item, index) => (
                                <div key={`reward-${item}-${index}`} className={classNames(styles.rewardItem, rewardCheckValue === item ? styles.rewardItemActive : '')} onClick={() => {
                                    this.setState({
                                        rewardCheckValue: item
                                    })
                                }}>
                                    {rewardCheckValue === item && <img src={`${BASE_IMG_URL}/common/icon12.png`} alt="" className={styles.icon} />}
                                    {rewardCheckValue !== item && <img src={`${BASE_IMG_URL}/common/icon12.png`} alt="" className={styles.icon} />}
                                    <div className={styles.text}>{item} V币</div>
                                </div>
                            ))}
                        </div>

                    </CommonPopup>

                    {/* 举报弹框 */}
                    <CommonPopup
                        visible={reportPopupStatus}
                        title='举报'
                        onCancelChange={() => this.closePopup()}
                        onConfirmButtonChange={() => this.reportConfirm()}
                    >
                        {/* children 插槽内容 */}
                        <div className={styles.reportPopupSlotBox}>
                            <div className={styles.reportText}><span className={styles.must}>*</span>举报理由<span>请选择举报理由</span></div>
                            <div className={styles.reportReasonListBox}>
                                <Radio.Group
                                    name="radiogroup"
                                    defaultValue={1}
                                    onChange={(e) => {
                                        this.setState({
                                            reportReason: e.target.value
                                        })
                                    }}
                                    options={reportReasonList}
                                />
                            </div>
                            <div className={styles.reportText}>举报描述</div>
                            <TextArea rows={4} placeholder="请输入举报理由" maxLength={600} />
                        </div>
                    </CommonPopup>

                    {/* 删除二次确认弹框 */}
                    <CommonAlert
                        visible={deletePopupStatus}
                        title='帖子删除后无法撤销，请确认是否删除'
                        onCancelChange={() => this.closePopup()}
                        onHidePopup={() => this.closePopup()}
                        onConfirmButtonChange={(id, type, deleteType) => this.postsUpdate()}
                    >
                    </CommonAlert>

                    {/* 表单弹窗 */}
                    {this.state.popupStatus && (
                        <div className={styles.formPopupWrapper}>
                            <div className={styles.formOverlay} onClick={() => this.setState({ popupStatus: false })}></div>
                            <div className={styles.formPopupBox} onClick={(e) => e.stopPropagation()}>
                                {/* 顶部导航栏 */}
                                <div className={styles.formHeader}>
                                    <div className={styles.formTitle}>{thread?.threadData?.form?.name || '填写信息'}</div>
                                    <div className={styles.formHeaderPlaceholder} onClick={() => this.setState({ popupStatus: false })}>
                                        <img src={setPostImage.close} alt="关闭" style={{ width: '24px', height: '24px' }} />
                                    </div>
                                </div>

                                {/* 表单内容区域 */}
                                <div className={styles.formContent}>
                                    {this.state.formInfo?.map((field: any, index: number) => (
                                        <div key={`form-field-${index}`} className={styles.formFieldBox}>
                                            <div className={styles.formFieldLabel}>
                                                {field.isRequired && <span className={styles.required}>*</span>}
                                                {index + 1}.{field.name}
                                                {field.type === 'checkbox' && <span className={styles.fieldType}>（多选）</span>}
                                            </div>

                                            {field.type === 'input' && (
                                                <div className={styles.inputWrapper}>
                                                    <textarea
                                                        placeholder={field.placeholder || '请输入'}
                                                        value={field.values || ''}
                                                        onChange={(e) => !this.state.auditStatus && this.onWzNum(index, e.target.value)}
                                                        maxLength={500}
                                                        className={styles.formTextarea}
                                                        disabled={this.state.auditStatus}
                                                    />
                                                </div>
                                            )}

                                            {field.type === 'checkbox' && (
                                                <div className={styles.optionGroup}>
                                                    {field.list?.map((option: any, key: number) => {
                                                        // 支持两种状态格式：list中的checked属性或values数组中的索引
                                                        const isChecked = option.checked || (Array.isArray(field.values) && field.values.includes(String(key)));
                                                        return (
                                                            <div
                                                                key={`checkbox-${index}-${key}`}
                                                                className={classNames(
                                                                    styles.optionItem,
                                                                    isChecked ? styles.optionItemActive : ''
                                                                )}
                                                                onClick={() => !this.state.auditStatus && this.onCheckBox(index, key)}
                                                            >
                                                                <span className={styles.optionLabel}>{option.label}</span>
                                                                {isChecked && <img src={`${BASE_IMG_URL}/common/icon10.png`} alt="" className={styles.checkedIcon}/>}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                            {field.type === 'radio' && (
                                                <div className={styles.optionGroup}>
                                                    {field.options?.map((option: any, key: number) => (
                                                        <div
                                                            key={`radio-${index}-${key}`}
                                                            className={classNames(
                                                                styles.optionItem,
                                                                (field.values === key || field.values === String(key)) ? styles.optionItemActive : ''
                                                            )}
                                                            onClick={() => !this.state.auditStatus && this.onRadioChange(index, key)}
                                                        >
                                                            <span className={styles.optionLabel}>{option}</span>
                                                            {(field.values === key || field.values === String(key)) && <img src={`${BASE_IMG_URL}/common/icon10.png`} alt="" className={styles.checkedIcon}/>}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {field.type === 'image' && (
                                                <div className={styles.uploadWrapper}>
                                                    {field.values ? (
                                                        <div className={styles.uploadedBox}>
                                                            <img src={typeof field.values === 'object' ? field.values.url : field.values} alt="已上传" className={styles.uploadedImage} />
                                                            {!this.state.auditStatus && <div className={styles.deleteBtn} onClick={() => {
                                                                let { formInfo } = this.state;
                                                                formInfo[index].values = null;
                                                                this.setState({ formInfo }, () => this.onCheckedFormStatus());
                                                            }}>×</div>}
                                                        </div>
                                                    ) : (
                                                        !this.state.auditStatus && <div className={styles.uploadBox} onClick={() => this.handleImageUploadClick(index)}>
                                                            <div className={styles.uploadIcon}>+</div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                {/* 用户协议 - 固定在按钮上方 - 只读模式下隐藏 */}
                                {!this.state.auditStatus && <div className={styles.formConsent}>
                                    <div
                                        className={classNames(
                                            styles.consentCheckbox,
                                            this.state.consentStatus ? styles.checked : ''
                                        )}
                                        onClick={() => {
                                            this.setState({ consentStatus: !this.state.consentStatus }, () => this.onCheckedFormStatus());
                                        }}
                                    ></div>
                                    <div className={styles.consentText}>
                                        我已阅读并接受 <span className={styles.link} onClick={(e) => {
                                            e.stopPropagation();
                                            this.props.history && this.props.history.push(`/selfDiscipline`);
                                        }}>用户协议</span> 和 <span className={styles.link} onClick={(e) => {
                                            e.stopPropagation();
                                            this.props.history && this.props.history.push(`/privacy`);
                                        }}>隐私政策</span>
                                    </div>
                                </div>}

                                {/* 底部提交按钮 - 只读模式下隐藏 */}
                                {!this.state.auditStatus && <div className={styles.formFooter}>
                                    <button
                                        className={classNames(
                                            styles.submitBtn,
                                            !this.state.submitStatus ? styles.submitBtnDisabled : ''
                                        )}
                                        disabled={!this.state.submitStatus}
                                        onClick={() => {
                                            if (this.state.submitStatus) {
                                                this.onSendServer(null);
                                            }
                                        }}
                                    >
                                        提交
                                    </button>
                                </div>}
                            </div>
                        </div>
                    )}

                    {/* 表单提交确认弹窗 */}
                    <div className={styles.formSubmitConfirmWrapper}>
                        <CommonAlert
                            visible={this.state.formSubmitConfirmVisible}
                            title="提示"
                            text="提交后将无法修改，请确认是否提交？"
                            onCancelChange={() => this.setState({ formSubmitConfirmVisible: false })}
                            onConfirmButtonChange={() => this.confirmSubmitForm()}
                            cancelText="取消"
                            confirmText="确认提交"
                        />
                    </div>
                </>}
                <div className={styles.postListBox}>
                    <PostList
                        threadId={this.props.threadId}
                        threadType={0}
                        handleSetState={(data, rep) => this.setState({ ...data }, () => {

                        })}
                        onPostLike={(comment) => {
                            window.globalEnsureLogin(() => this.props.likeClick?.(comment, 'post'));
                        }}
                        onDeleteComment={async (itemId) => {
                            this.setState({ selectedCommentId: itemId });
                            await this.handleDeleteComment();
                        }}
                        onSinkComment={async (itemId, currentIsSink) => {
                            this.setState({ selectedCommentId: itemId, selectedCommentIsSink: currentIsSink });
                            try {
                                await this.props.postsUpdate?.(itemId, 'sink', 'comment', currentIsSink);
                                Toast.success({ content: currentIsSink ? '取消沉贴成功' : '沉贴成功' });
                            } catch (error) {
                                Toast.error({ content: currentIsSink ? '取消沉贴失败' : '沉贴失败' });
                            }
                        }}
                        onStickyComment={async (itemId, currentIsSticky) => {
                            this.setState({ selectedCommentId: itemId, selectedCommentIsSticky: currentIsSticky });
                            try {
                                await this.props.postsUpdate?.(itemId, 'sticky', 'comment', currentIsSticky);
                                Toast.success({ content: currentIsSticky ? '取消置顶成功' : '置顶成功' });
                            } catch (error) {
                                Toast.error({ content: currentIsSticky ? '取消置顶失败' : '置顶失败' });
                            }
                        }}
                    ></PostList>
                </div>


            </div>
        );
    }

    //  隐藏/展示
    updateDisplay = () => {

    }
    // 屏蔽帖子
    updateHidden = () => {

    }

    handleThreadConversion = async (payload: ThreadConversionPayload) => {
        const { thread, threadId, user } = this.props;
        if (!getThreadConversionAccess(thread?.threadData, user?.userInfo).canConvert
            || String(payload.threadId) !== String(threadId)
            || payload.sourceType !== Number(thread?.threadData?.type)) {
            Toast.info({ content: '当前帖子不可转换，请刷新后重试' });
            throw new Error('当前帖子不可转换');
        }
        const blockedReason = getThreadConversionBlockedReason(thread?.threadData);
        if (blockedReason) {
            Toast.info({ content: blockedReason });
            throw new Error(blockedReason);
        }
        const result = await moveThread(threadId, getThreadConversionParams(payload));
        if (result?.code !== 0) {
            const message = result?.msg || '帖子转换未完成，请稍后重试';
            // 网络异常由请求层提示，业务拒绝则展示后端返回的原因。
            if (result?.errorType !== 'network') Toast.info({ content: message });
            throw new Error(message);
        }
    };

    // 首页右侧内容
    readerRight = () => {
        let { rightFixedBoxRight, rightFixedBoxHeight } = this.state;
        const { user, thread, threadId, threadAuthorInfo } = this.props;
        if (!thread) { return null }
        const threadData: any = thread.threadData;
        // let { topicList } = this.state;
        // 是否作者本人
        const { isSelf, canConvert } = getThreadConversionAccess(threadData, user?.userInfo);
        // let isLogin = false;
        let isPermissions = canConvert || threadData?.permissions?.canEdit || threadData?.permissions?.canEssence || threadData?.permissions?.canDelete || threadData?.permissions?.canSticky || threadData?.permissions?.canHide || (threadData?.permissions?.canDisplay && !isSelf) || threadData?.permissions?.canSink || threadData?.permissions?.canRecommend
        // 使用 rightFixedBox 的实际高度，如果没有获取到则使用默认值
        return (
            <>
            <div ref={(ref) => { this.rightContentRef = ref; }} className={styles.rightContent}>
                {/* 用户信息 */}
                <SidebarUserInfo isFeedback={threadData?.type == 2 ? true : false}></SidebarUserInfo>
                {/* 帖子管理 */}
                {isPermissions && <ManagePermissions
                    id={threadId}
                    threadData={threadData}
                    topicList={threadData?.topics}
                    isSelf={isSelf}
                    isApproved={threadData?.isApproved}
                    canEdit={threadData?.permissions?.canEdit}
                    canEssence={threadData?.permissions?.canEssence}
                    canDelete={threadData?.permissions?.canDelete && !threadData?.deletedAt}
                    canStick={threadData?.permissions?.canSticky}
                    canHidden={threadData?.permissions?.canHide}
                    canDisplay={threadData?.permissions?.canDisplay}
                    canSink={threadData?.permissions?.canSink}
                    canRecommend={threadData?.permissions?.canRecommend}
                    canConvert={canConvert}
                    handleConvert={this.handleThreadConversion}
                    isProhibited={threadData?.isProhibited}
                    isHidden={threadData?.isHidden}
                    isDisplay={threadData?.isDisplay}
                    isEssence={threadData?.isEssence}
                    isSticky={threadData?.isSticky}
                    stickyType={threadData?.stickyType}
                    stickyAt={threadData?.stickyExpiredAt && dayjs(threadData.stickyExpiredAt).isValid() ? threadData.stickyExpiredAt : undefined}
                    isSink={threadData?.isSink}
                    isRecommend={threadData?.isRecommend}
                    type={1}
                    handleSetState={(data, rep) => this.setState({ ...data })}
                    handleDisplay={() => console.log('显示')}
                    handleHidden={() => console.log('隐藏')}
                    className="custom-class"
                />}

                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>

            </div>
            <div ref={(ref) => { this.rightFixedBoxRef = ref; }} className={styles.rightFixedBox} style={{right: rightFixedBoxRight + 'px', display: this.state.showRightFixedBox ? 'block' : 'none'}}>
                {/* 用户信息 */}
                <SidebarUserInfo></SidebarUserInfo>
                {/* 帖子管理 */}
                {isPermissions && <ManagePermissions
                    id={threadId}
                    threadData={threadData}
                    topicList={threadData?.topics}
                    isSelf={isSelf}
                    isApproved={threadData?.isApproved}
                    canEdit={threadData?.permissions?.canEdit}
                    canEssence={threadData?.permissions?.canEssence}
                    canDelete={threadData?.permissions?.canDelete}
                    canStick={threadData?.permissions?.canSticky}
                    canHidden={threadData?.permissions?.canHide && isSelf}
                    canDisplay={threadData?.permissions?.canDisplay}
                    canSink={threadData?.permissions?.canSink}
                    canRecommend={threadData?.permissions?.canRecommend}
                    canConvert={canConvert}
                    handleConvert={this.handleThreadConversion}
                    isProhibited={threadData?.isProhibited}
                    isHidden={threadData?.isHidden}
                    isDisplay={threadData?.isDisplay}
                    isEssence={threadData?.isEssence}
                    isSticky={threadData?.isSticky}
                    stickyType={threadData?.stickyType}
                    stickyAt={threadData?.stickyExpiredAt && dayjs(threadData.stickyExpiredAt).isValid() ? threadData.stickyExpiredAt : undefined}
                    isSink={threadData?.isSink}
                    isRecommend={threadData?.isRecommend}
                    type={1}
                    handleSetState={(data, rep) => this.setState({ ...data })}
                    handleDisplay={() => console.log('显示')}
                    handleHidden={() => console.log('隐藏')}
                    className="custom-class"
                />}
            </div>
            </>
        );
    }

    render() {
        const { app, thread, sendConfirmPopupStatus, sendConfirmClick, handleState, user, serviceStatus, satisfactionLevel, currentSatisfactionIndex, judgeTextValue } = this.props;
        const threadData: any = thread?.threadData;
        const isSelf = (user?.userInfo as any)?.code && (user?.userInfo as any)?.code === threadData?.user?.code;
        const isProtected = isContentProtectionEnabled(thread?.threadData?.allowDownload);
        const pageProtectionProps = isProtected
            ? {
                ...getProtectedEventHandlers(isProtected),
                style: protectedMediaStyle,
            }
            : {};
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div ref={(ref) => { this.wrapperRef = ref; }} className={styles.wrapper} {...pageProtectionProps}>
                {this.readerLeft()}
                {this.readerRight()}

                {(threadData?.feedback?.isSendConfirm && isSelf && serviceStatus) && (
                    <div className={styles.serviceBox}>
                        <img
                            src={`${BASE_IMG_URL}/feedback/icon8.png`}
                            alt=""
                            className={styles.serviceIcon}
                            onClick={() => handleState?.({ sendConfirmPopupStatus: true })}
                        />
                        <img
                            src={`${BASE_IMG_URL}/common/close.png`}
                            alt=""
                            className={styles.serviceClose}
                            onClick={() => handleState?.({ serviceStatus: false })}
                        />
                    </div>
                )}

                <CommonPopupNew
                    visible={!!sendConfirmPopupStatus}
                    title="客服的反馈是否已解决你的问题?"
                    isShowConfirm={false}
                    isShowCancel={false}
                    onCancelChange={() => handleState?.({ sendConfirmPopupStatus: false })}
                >

                    <div className={styles.solveStatusBox}>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick?.(1)}>已解决</div>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick?.(2)}>未解决</div>
                    </div>

                    {/* 反馈评价完整版 使用完整版时，要放开弹框组件的取消和确认按钮，并完善sendConfirmClick里的接口参数 */}
                    {/* <div className={styles.judgeTitle}>客服的反馈是否已解决你的问题：</div>
                    <div className={classNames(styles.solveStatusBox, styles.solveStatusBox2)}>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick?.(1)}>已解决</div>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick?.(2)}>未解决</div>
                    </div>
                    <div className={styles.judgeTitle}>你对本次反馈服务的满意程度：</div>
                    <div className={styles.satisfactionLevelList}>
                        {satisfactionLevel.map((level, index) => (
                            <div className={classNames(styles.levelItem, currentSatisfactionIndex == index ? styles.levelItemActive : '')} onClick={() => {
                                handleState?.({ currentSatisfactionIndex: index })
                            }}>
                                <img src={currentSatisfactionIndex != index ? `${BASE_IMG_URL}${level.icon}.png` : `${BASE_IMG_URL}${level.icon}-active.png`} alt="表情" className={styles.icon}/>
                                <div className={styles.text}>{level.text}</div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.judgeTitle}>你对本次反馈服务的评价或建议：</div>
                    <textarea name="" id="" placeholder='如有请填写' className={styles.judgeTextarea}  value={judgeTextValue} onChange={(e) => {handleState?.({ judgeTextValue: e.target?.value })}}></textarea> */}
                </CommonPopupNew>
            </div>)
        }

    }
}

export default withRouter(ThreadDetailPCPage);
